/**
 * Lib.Common: Check for RTL inline direction.
 */


export default {
    get: function() {
        return this.$root.__app?.direction === 'rtl';
    }
}
